import { useEffect, useState } from 'react';
import { auth, ensureAuth } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';

export function useFirebaseAuth() {
  const [uid, setUid] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    const unsub = onAuthStateChanged(auth, u => {
      if (cancelled) return;
      if (u) { setUid(u.uid); setLoading(false); }
    });
    ensureAuth().catch(e => {
      if (!cancelled) { setError(e?.message ?? 'Auth failed'); setLoading(false); }
    });
    return () => { cancelled = true; unsub(); };
  }, []);

  return { uid, loading, error };
}
